import { TabletOutlined, DesktopOutlined } from "@ant-design/icons";
import { Divider, Button } from "antd";
import { DevicePreviewContext } from "../../../../contexts/device-preview-context";

const styles = {
  divider: {
    height: 40,
    color: "#737e85",
  },
  deviceColor: {
    activeColor: "#2b90ff",
    inactiveColor: "#737e85",
  },
};

function PreviewDevice() {
  return (
    <div>
      <DevicePreviewContext.Consumer>
        {({ previewDevice, toggleDevicePreview }) => (
          <>
            <Button
              type={previewDevice.type === "desktop" ? "link" : "text"}
              onClick={() => toggleDevicePreview("desktop")}
              icon={
                <DesktopOutlined
                  style={{
                    fontSize: 25,
                    color:
                      previewDevice.type === "desktop"
                        ? styles.deviceColor.activeColor
                        : styles.deviceColor.inactiveColor,
                  }}
                />
              }
            />

            <Divider type="vertical" style={styles.divider} />

            <Button
              type={previewDevice.type === "phone" ? "link" : "text"}
              onClick={() => toggleDevicePreview("phone")}
              icon={
                <TabletOutlined
                  style={{
                    fontSize: 25,
                    color:
                      previewDevice.type === "phone"
                        ? styles.deviceColor.activeColor
                        : styles.deviceColor.inactiveColor,
                  }}
                />
              }
            />
          </>
        )}
      </DevicePreviewContext.Consumer>
    </div>
  );
}

export default PreviewDevice;
